// removed by extract-text-webpack-plugin
module.exports = {"component":"_3X8lqGmQWevSIM5b9DS6DC","agree":"DkikR7s455Dv920TEPLfU","disabledBtn":"_1608-R46dD0TrLg8Os32L2"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/ServiceDetailTermsModal/ServiceDetailTermsModal.scss
 ** module id = 1025
 ** module chunks = 0
 **/